import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";
import "firebase/analytics";
import "firebase/performance";

import { TYPES, TEAMS } from '../utils/constants';

let firebaseConfig = {
	apiKey: "AIzaSyAXkdfsRWMr_wSjcR9hmCLJ_QGQVoGd7sQ",
	authDomain: "codewords-fae2f.firebaseapp.com",
	databaseURL: "https://codewords-fae2f-default-rtdb.firebaseio.com",
	projectId: "codewords-fae2f",
	storageBucket: "codewords-fae2f.appspot.com",
	messagingSenderId: "330420887194",
	appId: "1:330420887194:web:787c6fa61a7e2e35ac8923",
	measurementId: "G-WG68Z4MGFT"
};

if (!process.env.isProd) {
	// firebaseConfig.databaseURL = "http://192.168.0.10/?ns=codewords-fae2f";
}

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export const db = firebase.firestore();
export const functions = firebase.functions();
export const analytics = firebase.analytics();
export const performance = firebase.performance();

if (!process.env.isProd) {
	// auth.useEmulator('http://192.168.0.10:9099/');
	// functions.useEmulator("192.168.0.10", 5001);
	// db.useEmulator("192.168.0.10", 8080);
}

// const joinGame = functions.httpsCallable('joinGame');
// const startGame = functions.httpsCallable('startGame');
export const giveClue = functions.httpsCallable('giveClue');
export const cleanAFK = functions.httpsCallable('cleanAFK');
const doCreatePubMatch = functions.httpsCallable('createPubMatch');
const doCreateGame = functions.httpsCallable('createGame');
// export const guess = functions.httpsCallable('guess');
// const rematch = functions.httpsCallable('rematch');

export const serverTimestamp = firebase.firestore.FieldValue.serverTimestamp;
export const arrayUnion = firebase.firestore.FieldValue.arrayUnion;

export function createGame(authID, playerName, wordsList, timerLength) {
	return doCreateGame({ wordsList, timerLength }).then(gameIDSnap => {
		const gameID = gameIDSnap.data.gameID;
		const game = gameIDSnap.data.game;
		console.log('created game id:', gameID);
		return joinGame({ authID, gameID, playerName }).then(() => gameID);
	});
}

export function createPubMatch(authID, playerName, wordsList, timerLength, numPlayersRequired) {
	wordsList = wordsList || 'original';

	return doCreatePubMatch({ wordsList, timerLength, numPlayersRequired }).then(gameIDSnap => {
		const gameID = gameIDSnap.data.gameID;
		const game = gameIDSnap.data.game;
		console.log('pub match:', gameID);
		return joinGame({ authID, gameID, playerName }).then(() => gameID);
	});
}

export async function joinGame({ authID, gameID, playerName, requestedTeam }) {
	const ref = db.collection('games').doc(gameID).collection('playersInput');

	requestedTeam = requestedTeam || null;
	if (requestedTeam !== TEAMS.one && requestedTeam !== TEAMS.two) {
		await ref.get().then(snap => {
			let teamCounter = 0;
			snap.forEach(p => {
				let player = p.data();
				if (player.requestedTeam === TEAMS.one) {
					teamCounter--;
				}
				else if (player.requestedTeam === TEAMS.two) {
					teamCounter++;
				}
			})

			if (teamCounter > 0) {
				requestedTeam = TEAMS.one;
			}
			else if (teamCounter < 0) {
				requestedTeam = TEAMS.two;
			}
			else {
				requestedTeam = Math.round(Math.random()) ? TEAMS.one : TEAMS.two;
			}
		});
	}

	return ref.doc(authID).set({
		name: playerName,
		requestedTeam,
		selectedCards: [],
		guessWords: [],
		timestampCreated: serverTimestamp(),
	})
	.then(() => {
		localStorage.setItem('playerName', playerName);
		console.log(`${playerName} joined game ${gameID}`);
		return { authID, gameID, playerName };
	});
}

export async function unJoin({ authID, gameID, game }) {
	if (!authID || !gameID) {
		return;
	}
	if ((game && game.players || []).find(p => p.id === authID)) {
		await db.collection('games').doc(gameID).collection('playersInput').doc(authID).update({
			requestedTeam: null,
			clickedStart: null,
			clickedRematch: null,
			selectedCards: [],
			guessWords: []
		});
	}
	else {
		await db.collection('games').doc(gameID).collection('playersInput').doc(authID).delete();
	}
}

export function syncTime({ authID, gameID }) {
	if (!authID || !gameID) {
		return;
	}

	let returnDate;
	return new Promise((r, x) => {
		const unlisten = db.collection('games').doc(gameID).collection('playersInput').doc(authID).onSnapshot(snap => {
			const { syncTimeClientMillis, syncTimeServerTimestamp } = snap.data();
			if (!syncTimeClientMillis || !syncTimeServerTimestamp) {
				return;
			}
			const serverMillis = syncTimeServerTimestamp.seconds * 1000 + syncTimeServerTimestamp.nanoseconds / 1000000;
			const totalRequestMillis = returnDate - syncTimeClientMillis;
			const serverClientdifferenceMillis = serverMillis - syncTimeClientMillis;
			serverTimeOffsetMillis = serverClientdifferenceMillis - totalRequestMillis / 2;
			unlisten();
			r();
		});

		db.collection('games').doc(gameID).collection('playersInput').doc(authID).update({
			syncTimeServerTimestamp: serverTimestamp(),
			syncTimeClientMillis: Date.now()
		})
		.then(() => {
			returnDate = Date.now();
		});
	});
}

export let serverTimeOffsetMillis = 0;
